<template>
  <SButtonIcon
    action-type="quaternary"
    :aria-label="tr('general.close')"
    class="s-alert__close"
    :color="color"
    icon="fa-regular fa-xmark"
    size="inline"
    @click="emit('click')"
  />
</template>

<script setup lang="ts">
import { useI18nGeneral } from "@solvari/translations";

import type { Color } from "@/lib/components/types";

import SButtonIcon from "@/lib/components/atoms/button/SButtonIcon.vue";

// Split out of SAlert so the general translation domain is only fetched by
// alerts that are actually closable, not by every SAlert in every bundle
defineProps<{ color: Color }>();
const emit = defineEmits<(event: "click") => void>();

const { tr } = useI18nGeneral();
</script>
